"use client";
import Slider from "react-slick";
import { useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import Image from "next/image";

const OurPartners = ({ ourPartnersData }: any) => {
  const sliderRef = useRef<Slider | null>(null);
  const multiple = ourPartnersData.length > 1;

  const settings = {
    dots: false,
    arrows: false,
    infinite: multiple,
    speed: 500,
    autoplay: multiple,
    autoplaySpeed: 4500,
    slidesToShow: 4,
    slidesToScroll: 1,
    centerMode: multiple,
    centerPadding: "24px",
    pauseOnHover: true,
    dotsClass: "slick-dots hero-dots",
    responsive: [
      {
        breakpoint: 1400,
        settings: { slidesToShow: 3, centerPadding: "16px" },
      },
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2, centerPadding: "8px" },
      },
      {
        breakpoint: 550,
        settings: { slidesToShow: 1, centerPadding: "0px" },
      },
    ],
  };
  return (
    <>
      <style>
        {`
            .partner-section{
                 padding :80px 0;
                 background : #ffffff;
            }
                 .partner-container{
                 max-width:1320px;
          margin:auto;
          padding:50px 70px;
          background:#f8f8ff;
          border-radius:24px;
          position:relative;
                 }
          .partner-header{
          text-align:center;
          margin-bottom:40px;
        }
            .partner-label{
          color:#4654E8;
          font-size:15px;
          font-weight:700;
          letter-spacing:2px;
          text-transform:uppercase;
          margin-bottom:8px;
        }
            .partner-label{
          color:#4654E8;
          font-size:12px;
          font-weight:700;
          letter-spacing:2px;
          text-transform:uppercase;
          margin-bottom:8px;
        }
          .partner-title{
          font-size:34px;
          font-weight:700;
          color:#222;
          margin-bottom:10px;
        }
           .partner-subtitle{
          color:#707070;
          font-size:16px;
        }
          .partner-slider-wrapper{
          position: relative;
  padding: 0 50px;
          }
  .partner-slider .slick-slide{
  padding:12px;
  }
  .partner-card{
   height: 90px;
     background: #fff;
       border-radius: 16px;
  display: flex !important;
  align-items: center;
    justify-content: center;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
  transition: 0.3s;
  }
  .partner-card:hover {
    transform: translateY(-5px) scale(1.08);;

}
  .partner-logo{
    object-fit: contain;
     width: 140px;
  height: 60px;

  }
  .partner-arrow{
    position: absolute;
  top: 50%;
  transform: translateY(-50%);
    width: 44px;
  height: 44px;
  border: none;
  border-radius: 50%;
    background: #fff;
      box-shadow: 0 5px 18px rgba(0, 0, 0, 0.12);
  cursor: pointer;
  z-index: 20;
 display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.25s;

  }
.partner-arrow:hover {
  transform: translateY(-50%) scale(1.08);
}
  .partner-left {
  left: 0;
}
.partner-right {
  right: 0;
}
  @media (max-width: 768px) {
   .partner-container {
    padding: 35px 20px;
  }
    .partner-slider-wrapper {
    padding: 0 35px;
  }
    .partner-title {
    font-size: 20px;
  }
    .partner-subtitle {
    font-size: 12px;
  }
.partner-card {
    height: 75px;
    align-items: center;
  justify-content: center;
  }
 .partner-logo {
   object-fit: contain;
    width: 110px;
    height: 50px;
  }

  }
            `}
      </style>
      <section className="partner-section">
        <div className="partner-container">
          <div className="partner-header">
            <div className="partner-label">OUR PARTNERS </div>
            {/* <h2 className="partner-title">Our Clients & Sponsors</h2>
            <p className="partner-subtitle">
              Proudly partnered with leading brands who support our vision.
            </p> */}
          </div>
          <div className="partner-slider-wrapper">
            <button
              className="partner-arrow partner-left"
              onClick={() => sliderRef.current?.slickPrev()}
            >
              <ChevronLeft size={20} />
            </button>

            <Slider {...settings} ref={sliderRef} className="partner-slider">
              {ourPartnersData.map((partner: any) => (
                <div key={partner.id}>
                  <div className="partner-card">
                    <Image
                      src={partner.Image_Path}
                      alt={partner.Title}
                      width={150}
                      height={70}
                      className="partner-logo"
                    />
                  </div>
                </div>
              ))}
            </Slider>

            <button
              className="partner-arrow partner-right"
              onClick={() => sliderRef.current?.slickNext()}
            >
              <ChevronRight size={20} />
            </button>
          </div>
        </div>
      </section>
    </>
  );
};
export default OurPartners;
